import { render, staticRenderFns } from "./DocumentPortalSetupQuestionnairesView.vue?vue&type=template&id=346fc69a&"
import script from "./DocumentPortalSetupQuestionnairesView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSetupQuestionnairesView.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports